module.exports = __webpack_public_path__ + "static/media/27.718889d5.png";